import React from 'react'
import { getTextByKey, getTimeFormat } from '@feedback/utils/util'
import ItemWrap from '../ItemWrap/index'
import './index.scss'
//工单信息
interface Props {
  ticketInfo: any
  openImageModal: any
}
const getTextByKeyFn = (value: string) => {
  if (value == 'work_order') {
    return getTextByKey('feedback id')
  } else if (value == 'question_type') {
    return getTextByKey('question type')
  } else {
    return value
  }
}

const TicketInfo: React.FC<Props> = ({ ticketInfo, openImageModal }) => {
  return (
    <ItemWrap timestamp={getTimeFormat(ticketInfo.created_at)}>
      <div className='c-ticket-content'>
        <p className='title'>{ticketInfo.title}</p>
        <div className='simple-info'>
          {Object.keys(ticketInfo.other).map((item) => {
            if (item == 'origin_date') {
              return ''
            }
            if (
              !!ticketInfo.other[item].type &&
              ticketInfo.other[item].type == 4
            ) {
              return (
                <p className='picture-info' key={item}>
                  <p className='label' style={{ marginBottom: 3 }}>
                    {getTextByKey('images')}:
                  </p>
                  <span>{getTextByKeyFn(item)}</span>

                  <div className='picture-list'>
                    {ticketInfo.other[item].data.map((path: string) => (
                      <img
                        src={path}
                        alt=''
                        key={path}
                        onClick={() => openImageModal(path)}
                      />
                    ))}
                  </div>
                </p>
              )
            }
            return ticketInfo.other[item] ? (
              <p className='desc-info' key={item}>
                <span className='label'>{getTextByKeyFn(item)} :</span>

                <p className='value'>{ticketInfo.other[item].data}</p>
              </p>
            ) : null
          })}
        </div>
        {ticketInfo.content && (
          <div className='desc-info'>
            <span className='label'>{getTextByKey('description')}:</span>
            <p className='info'>{ticketInfo.content}</p>
          </div>
        )}
        {ticketInfo.images.length > 0 && (
          <div className='picture-info'>
            <span className='label'>{getTextByKey('images')}:</span>
            <div className='picture-list'>
              {ticketInfo.images.map((item: { path: string }) => (
                <img
                  src={item.path}
                  alt=''
                  key={item.path}
                  onClick={() => openImageModal(item.path)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </ItemWrap>
  )
}

export default TicketInfo
